import { memo } from "react";

import Image from "next/image";

import type { CountryDropdown, CultureNames, LocaleLabel } from "@repo/ui/types/cms";

type CountryOptionProps = {
  culture: CountryDropdown;
  cultureNames: CultureNames;
  selectedCountry: CountryDropdown | null;
  testidPrefix?: string;
};

export const CountryOption = memo(
  ({ culture, cultureNames, selectedCountry, testidPrefix }: CountryOptionProps) => {
    const cultureLabel = cultureNames[culture.localeCode];

    const cultureCode = selectedCountry?.localeCode.slice(0, 2) || "es";

    const isLocaleLabel = (value: string): value is LocaleLabel =>
      value === "en" || value === "es" || value === "pt";

    const cultureName =
      cultureLabel && isLocaleLabel(cultureCode) ? cultureLabel[cultureCode] : culture.name;

    return (
      <div
        className="flex flex-row items-center cursor-pointer!"
        data-testid={`${testidPrefix ? `${testidPrefix}-` : ""}country-selector-${culture.localeCode}`}
      >
        <Image
          src={culture.flagImageUrl}
          alt={cultureName}
          width={24}
          height={16}
          className="mr-2 h-4 w-6 rounded-sm object-cover cursor-pointer!"
          loading="lazy"
          data-testid={`${testidPrefix ? `${testidPrefix}-` : ""}country-selector-${culture.localeCode}-flag`}
        />
        <span
          className="text-sm cursor-pointer!"
          data-testid={`${testidPrefix ? `${testidPrefix}-` : ""}country-selector-${culture.localeCode}-name`}
        >
          {cultureName}
        </span>
      </div>
    );
  },
);

CountryOption.displayName = "CountryOption";

export default CountryOption;
